<template>
  <div class="wxlogin_index" style="width:100%;">
  </div>
</template>

<script>
import { wxlogin } from '@/api/spreader/user';

export default {
  name: "wxlogin_index",
  components: {
  },
  created() {
    let data = {
      code: this.$route.query.code
    }
    return new Promise((resolve, reject) => {
      wxlogin(data).then(res => {
        if (res.status == 200) {
          sessionStorage.setItem('userInfo', JSON.stringify(res.data));
          this.$router.push('/spreader/home');
          this.$message('微信登录成功');
        } else {
          this.$message(res.message);
        }
      })
    })
  },
  destroyed: function () {
  },
  mounted: function () {
  },
  methods: {
  },
  data() {
    return {
    };
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/spreader/wxlogin.vue